import { runInAction } from 'mobx';
import { ocapiClient } from '../../../../../api-clients/ocapi/client';
import { getFetchedDataPayload } from '../../../../../utils/fetched-data/get-fetched-data-payload';
import { logger } from '../../../../../utils/logger';
import { isMemberSignedIn } from '../../../selectors/member/is-member-signed-in';
import { loyaltyDomainStore } from '../../../store';
export const removeMemberWatchlistFilm = async (filmId) => {
    if (!isMemberSignedIn()) {
        const error = "Cannot remove film from watchlist when member isn't signed in.";
        logger.error(error);
        throw new Error(error);
    }
    // TODO: Updating the default value has no effect. #286490
    const watchlistFilms = getFetchedDataPayload(loyaltyDomainStore.data.memberWatchlistFilmsById, {});
    let removedFilm;
    try {
        if (watchlistFilms) {
            removedFilm = watchlistFilms[filmId];
            /**
             * This action is based on the optimistic UI concept
             * Therefore all changes are performed before the API response and rolled back if an error occurs
             */
            runInAction(() => delete watchlistFilms[filmId]);
            await ocapiClient.instance.v1.loyalty.members.watchlistFilms.remove(filmId);
        }
    }
    catch (error) {
        if (watchlistFilms)
            runInAction(() => (watchlistFilms[filmId] = removedFilm));
        throw error;
    }
};
